import { createContext, type ReactNode, useContext } from 'react';

import type { DirectionalIndicatorEdge } from '../dnd/core';

export type CollectionReorderIndicator = {
  targetItemId: string;
  edge: DirectionalIndicatorEdge;
};

export type CollectionReorderVisualValue = {
  reorderDragActive: boolean;
  indicator: CollectionReorderIndicator | null;
};

const CollectionReorderVisualContext = createContext<CollectionReorderVisualValue | null>(null);

export function useCollectionReorderVisual(): CollectionReorderVisualValue {
  return (
    useContext(CollectionReorderVisualContext) ?? {
      reorderDragActive: false,
      indicator: null,
    }
  );
}

export function CollectionReorderVisualProvider({
  value,
  children,
}: {
  value: CollectionReorderVisualValue;
  children: ReactNode;
}) {
  return (
    <CollectionReorderVisualContext.Provider value={value}>
      {children}
    </CollectionReorderVisualContext.Provider>
  );
}
